import { TOTAL_COST } from "helpers/metrics/targets/total/formula-total-cost";
import { TOTAL_RETAIL } from "helpers/metrics/targets/total/formula-total-retail";
import { UNITS } from "helpers/metrics/targets/total/formula-units";
import { AVERAGE_UNITS } from "helpers/metrics/targets/total/formula-average-units";
import { AUR } from "helpers/metrics/targets/total/formula-aur";
import { UNIT_ROW_PERCENTAGE_PLAN } from "helpers/metrics/targets/total/formula-unit-row-percentage-plan";
import { PLAN_ROWS } from "helpers/metrics/targets/total/formula-plan-rows";
import { STORE_WITH_UNITS } from "helpers/metrics/targets/total/formula-store-with-units";
import { AVERAGE_COST } from "helpers/metrics/targets/total/formula-average-cost";
import { AVERAGE_DEPTH } from "helpers/metrics/targets/total/formula-average-depth";
import { IMU_PERCENTAGE } from "helpers/metrics/targets/total/formula-imu-percentage";

export const formulaByKind = {
    UNIT_ROW_PERCENTAGE_PLAN,
    UNITS,
    AUR,
    AVERAGE_UNITS,
    TOTAL_COST,
    TOTAL_RETAIL,
    PLAN_ROWS,
    STORE_WITH_UNITS,
    AVERAGE_COST,
    AVERAGE_DEPTH,
    IMU_PERCENTAGE,
};
